import { type FC, useState } from 'react';

import GetHelpModal from 'dibs-contact-1stdibs/exports/GetHelpModal.ts';
import { type AuthModalProps } from 'dibs-contact-1stdibs/exports/getHelpTypes.ts';
import { getBuyerSearchParamsProps } from 'dibs-contact-1stdibs/exports/getSearchParamsProps.ts';
import replaceSearchParam from 'dibs-contact-1stdibs/exports/replaceSearchParam.ts';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader.js';
import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/urls';

import { Spinner } from 'dibs-elements/exports/Spinner.tsx';

import styles from './GetHelpEmbeddedWrapper.module.css';

const GetHelpEmbeddedWrapper: FC = () => {
    const [modalProps, setModalProps] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const showAuthModal = async ({ onSuccess, ...props }: AuthModalProps): Promise<void> => {
        setIsLoading(true);

        const { userId } = await authModalLoader.show({
            action: authModalLoader.constants.LOGIN,
            flow: props.isChatFlow ? authModalLoader.constants.CONTACT_1STDIBS_FLOW : '',
            ga: { label: 'support chat' },
        });

        setIsLoading(false);

        if (userId) {
            if (props.channel === 'liveChat' || props.isChatFlow) {
                replaceSearchParam('channel')('liveChat');
                window.location.reload();
            } else {
                setModalProps(props);
                if (onSuccess) {
                    onSuccess();
                }
            }
        }
    };

    if (isLoading) {
        return <Spinner containerClass={styles.spinner} />;
    }

    return (
        <GetHelpModal
            placement="buyerContactLanding"
            onHelpTypeChange={replaceSearchParam('helpType')}
            onOrderIdChange={replaceSearchParam('orderId')}
            onTopicChange={replaceSearchParam('topic')}
            showAuthModal={showAuthModal}
            {...getBuyerSearchParamsProps()}
            {...modalProps}
            isEmbedded
            onClose={() => {
                window.location.href = handleLocaleUrl('/', GLOBAL_CLIENT_ONLY_LOCALE);
            }}
        />
    );
};

export default GetHelpEmbeddedWrapper;
